import { useState } from "react";

import { useSalesTasks } from "./useSalesTasks";

export type TaskType = "sales" | "room" | "event";

export interface UseTaskDashboardOptions {
  initialTaskType?: TaskType;
}

export const useTaskDashboard = (options: UseTaskDashboardOptions = {}) => {
  const { initialTaskType = "sales" } = options;

  // Track the current task type
  const [currentTaskType, setCurrentTaskType] = useState<TaskType>(initialTaskType);

  // Fetch sales tasks using the existing hook
  const salesTasks = useSalesTasks();

  // We'll add room and event tasks later
  // For now, just return the sales tasks

  return {
    currentTaskType,
    eventTasks: {
      isLoading: false,
      myTasks: [],
    },
    roomTasks: {
      isLoading: false,
      myTasks: [],
    },
    salesTasks: {
      handleClearTasks: salesTasks.handleClearTasks,
      handleCompleteTask: salesTasks.handleCompleteTask,
      handleCreateTask: salesTasks.handleCreateTask,
      handleDeleteTask: salesTasks.handleDeleteTask,
      handleReassignTask: salesTasks.handleReassignTask,
      isClearingTasks: salesTasks.isClearingTasks,
      isLoading: salesTasks.tasksDueSoonStatus === "pending",
      myTasks: salesTasks.myTasks,
      tasksDueSoon: salesTasks.tasksDueSoon,
    },
    setCurrentTaskType,
  };
};
